import { AllManufacturersQueryResult } from '@app/sanity.types';

const groupMakersByFirstLetter = (makers: AllManufacturersQueryResult) => {
  const groups = new Map<string, AllManufacturersQueryResult>();
  makers.forEach((maker) => {
    const firstLetter = maker.name.charAt(0).toUpperCase();
    if (!groups.has(firstLetter)) {
      groups.set(firstLetter, []);
    }
    groups.get(firstLetter).push(maker);
  });
  return groups;
};

export { groupMakersByFirstLetter };
